import { TransactionsContextType } from "@zenith/context/global-context/types";
import { memo } from "react";
import CopyToClipboard from "@zenith/components/ui/CopyToClipboard/CopyToClipboard";
import { formatCurrency } from "@zenith/utils";
import { OperationFullDTO } from "@zenith/services/transactions";
import { shouldShow, truncateText } from "@zenith/utils/TransactionDisplayHelpers";

export interface WithdrawalTransactionDetailsProps {
  transaction: TransactionsContextType;
}

const WithdrawalTransactionDetails = memo(function WithdrawalTransactionDetails(
  props: WithdrawalTransactionDetailsProps
) {
  const { transaction } = props;
  const isFeeTransaction = transaction?.partialTransactionType?.toUpperCase() === "FEE";
  const paymentMethod = transaction?.paymentMethod;
  const paymentMethodString = paymentMethod as string;
  
  const isPosOrder = 
    paymentMethod === OperationFullDTO.paymentMethod.POS_ORDER ||
    paymentMethodString === "POS_ORDER";

  if (isFeeTransaction) {
    return (
      <>
        <div className="mb-2.5 flex justify-between">
          <p className="text-neutral-600">Amount</p>
          <p className="font-medium text-neutral-900">
            {formatCurrency(transaction?.totalAmount, true)}
          </p>
        </div>
      </>
    );
  }

  if (isPosOrder) {
    return (
      <>
        {shouldShow(transaction?.description) && (
          <div className="mb-2.5 flex justify-between">
            <p className="text-neutral-600">Description</p>
            <div className="w-80">
              <p className="text-right font-medium text-neutral-900 break-words">
                {truncateText(transaction?.description)}
              </p>
            </div>
          </div>
        )}
      </>
    );
  }

  return (
    <>
      {shouldShow(transaction?.beneficiaryName) && (
        <div className="mb-2.5 flex justify-between">
          <p className="text-neutral-600">Beneficiary Name</p>
          <p className="font-medium text-neutral-900">
            {transaction?.beneficiaryName}
          </p>
        </div>
      )}

      {shouldShow(transaction?.bankName) && (
        <div className="mb-2.5 flex justify-between">
          <p className="text-neutral-600">Beneficiary Bank</p>
          <p className="font-medium text-neutral-900">
            {transaction?.bankName}
          </p>
        </div>
      )}

      {shouldShow(transaction?.beneficiaryAccountNumber) && (
        <div className="mb-2.5 flex justify-between">
          <p className="text-neutral-600">Beneficiary Account</p>
          <CopyToClipboard text={transaction?.beneficiaryAccountNumber} />
        </div>
      )}

      {shouldShow(transaction?.sessionId) && (
        <div className="mb-2.5 flex justify-between">
          <p className="text-neutral-600">Session ID</p>
          <p className="font-medium text-neutral-900">
            {transaction?.sessionId}
          </p>
        </div>
      )}

      {shouldShow(transaction?.description) && (
        <div className="mb-2.5 flex justify-between">
          <p className="text-neutral-600">Description</p>
          <div className="w-3/5 text-right">
            <p className="font-medium text-neutral-900 break-words">
              {truncateText(transaction?.description)}
            </p>
          </div>
        </div>
      )}
    </>
  );
});

export default WithdrawalTransactionDetails;